import React from "react";
import { useTranslate } from "../../hooks/LanguageProvider";

interface StepItem {
  id: number;
  title: string;
  icon: React.ReactNode;
}

interface RfqStepsProps {
  steps: StepItem[];
  currentStep: number;
  onStepClick: (step: number) => void;
}

export default function RfqSteps({
  steps,
  currentStep,
  onStepClick,
}: RfqStepsProps) {
  const { translate } = useTranslate();

  return (
    <>
      <div className="steps-container">
        {steps.map((s) => (
          <div
            key={s.id}
            onClick={() => onStepClick(s.id)}
            className={`step-pill ${currentStep === s.id ? "active" : ""}`}
          >
            <div className="d-flex align-items-center justify-content-center gap-2">
              {s.icon}
              <span>{translate(s.title)}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="progress-aida">
        <div
          className="progress-fill"
          style={{ width: `${(currentStep / steps.length) * 100}%` }}
        />
      </div>
    </>
  );
}